import script from "./PortfolioTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioTable.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioTable.vue?vue&type=style&index=0&id=113e3de5&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-113e3de5"]])

export default __exports__